import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import { getRGBA } from 'utils/color'

interface TableStatusProps {
  status: 'active' | 'disabled'
}

const styles = makeStyles(() => ({
  chip: {
    padding: '0.25rem 0.75rem',
    borderRadius: '0.75rem',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    width: 'fit-content',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },

  chipSuccess: {
    color: '#2E7D32 !important',
    backgroundColor: `${getRGBA('#2E7D32', 0.08)} !important`,
    opacity: 1,
  },

  chipUnauthorized: {
    color: '#EF6C00 !important',
    backgroundColor: `${getRGBA('#EF6C00', 0.08)} !important`,
    opacity: 1,
  },
}))

const ContractStatus: React.FC<TableStatusProps> = ({ status }) => {
  const classes = styles()

  return (
    <span className={clsx(classes.chip, status === 'active' ? classes.chipSuccess : classes.chipUnauthorized)}>
      {status === 'active' ? 'Ativo' : 'Desativado'}
    </span>
  )
}

export default ContractStatus
